import { Game } from 'chessboard/model/game/types';

/**
 * Determine from the flags if a move is a castle.
 */
export function isCastle(move: Game.Move.Model): boolean {
  return (
    move.flags === Game.Move.Flags.AnyCastle ||
    move.flags === Game.Move.Flags.KingsideCastle ||
    move.flags === Game.Move.Flags.QueensideCastle
  );
}
